import type { GuestTabletWelcome } from "@/types/guestTablet";

type Props = {
  welcome: GuestTabletWelcome;
  isDemo: boolean;
};

/** Nur Begrüßung – ohne persönliche Detailkacheln (Schritt vor Datenprüfung). */
export function TabletWelcomeScreen({ welcome, isDemo }: Props) {
  return (
    <section className="guest-tablet-card flex flex-col items-center justify-center p-8 text-center md:p-12">
      {isDemo && (
        <p className="mb-3 inline-block rounded-full bg-amber-100 px-3 py-1 text-sm font-medium text-amber-900 dark:bg-amber-900/40 dark:text-amber-100">
          Demo-Modus
        </p>
      )}
      {welcome.is_returning_guest && (
        <p className="mb-2 text-lg font-medium text-emerald-700 dark:text-emerald-300">
          Willkommen zurück
        </p>
      )}
      <h1 className="guest-tablet-hero-name text-emerald-950 dark:text-emerald-50">
        {welcome.guest_display_name}
      </h1>
      {welcome.family_hint && (
        <p className="mt-2 text-lg text-emerald-800/70 dark:text-emerald-100/70">{welcome.family_hint}</p>
      )}
      <p className="mt-6 max-w-2xl text-2xl leading-relaxed text-emerald-900/80 dark:text-emerald-50/80">
        {welcome.greeting_text}
      </p>
      <p className="mt-8 text-lg text-emerald-800/70 dark:text-emerald-100/70">
        Bitte nehmen Sie an der Rezeption Platz – wir bereiten Ihren Check-in vor.
      </p>
    </section>
  );
}
